<template>
    <div class="row">
        <div class="py-3 d-flex flex-row align-items-center justify-content-between">
            <div class="col-12">
                <div class="card card-shape home-box">
                    <div class="card-header d-flex flex-row align-items-center">
                        <h6 class="m-0 fw-bold text-green">COA Reconciliation Entry</h6>
                    </div>
                    <div class="card-body">
                        <form class="form" @submit.prevent="storeData">
                            <div class="row">
                                <div class="err-accounts">
                                    <errors v-if="form.errors.accounts">
                                        {{ form.errors.accounts[0] }}
                                    </errors>
                                </div>
                                <div class="row mt-2" v-for="(field, index) in entities" :key="index">
                                    <div class="col-12 col-md-3">
                                        <b-form-group>
                                            <label class="akkurate-dark small" for="dr_amount">COA
                                                <star></star>
                                            </label>
                                            <multiselect v-model="field.coa_subhead" name="coa_subhead"
                                                :options="coaSubheadOptions" class="mt-2 field-container" label="code"
                                                :custom-label="customLabel" required>
                                            </multiselect>
                                            <errors v-if="form.errors.account_type">
                                                {{ form.errors.account_type[0] }}
                                            </errors>
                                        </b-form-group>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <label class="akkurate-dark small" for="amount">Balance
                                            <star></star>
                                        </label>
                                        <b-form-group label-for="amount">
                                            <b-form-input id="amount" name="amount" class="mt-2 field-container fields"
                                                type="number" placeholder="Enter Amount" step="any"
                                                v-model="field.amount" required></b-form-input>
                                            <errors v-if="form.errors.amount">
                                                {{ form.errors.amount[0] }}
                                            </errors>
                                        </b-form-group>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <label class="akkurate-dark small" for="amount">Transaction
                                            Date <star></star></label>
                                        <b-form-input type="date" v-model="field.trans_date"
                                            class="mt-2 field-container fields" required></b-form-input>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <b-form-group>
                                            <label class="akkurate-dark small" for="dr_amount">Description <star></star>
                                            </label>
                                            <b-form-input id="coa_description" v-model="field.coa_description"
                                                name="coa_description" class="mt-2 field-container fields"
                                                placeholder="Enter COA Description" type="text" required></b-form-input>
                                            <errors v-if="form.errors.coa_description">
                                                {{ form.errors.coa_description[0] }}
                                            </errors>
                                        </b-form-group>
                                    </div>
                                    <div class="col mt-auto">
                                        <a title="Delete" class="btn btn-sm akkurate-danger-btn text-white"
                                            @click="removeField(index)">
                                            <span class="akkurate-small"><font-awesome-icon
                                                    :icon="['fas', 'trash']" /></span>
                                        </a>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <button type="button" @click="addAccount"
                                            class="btn akkurate-green-btn text-white btn-size">
                                            <font-awesome-icon class="me-2" :icon="['fas', 'plus']" />
                                            Add
                                        </button>
                                    </div>
                                </div>
                                <p class="akkurate-danger small">{{ acc_error }}</p>
                            </div>
                            <hr />
                            <div class="text-center py-3">
                                <SaveButton :isSaving="isSaving" />
                                <button type="reset" @click="resetForm"
                                    class="btn akkurate-gray-btn text-white btn-size my-2 ms-3">
                                    <font-awesome-icon class="me-2" :icon="['fas', 'rotate-right']" />
                                    Reset
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from 'vue-multiselect';
import ApiService from "@/core/services/api.service";
import SaveButton from "@/views/main/components/SaveButton.vue";

export default {
    name: 'COAReconciliationEntry',
    components: {
        SidebarView,
        TopbarView,
        Footer,
        Multiselect,
        SaveButton
    },
    mounted() {
        let token = localStorage.getItem('token');
        if (!token) {
            this.$router.push({ path: '/login' });
        }
        this.coa_dropdown();
    },
    data() {
        return {
            ...this.initialState(),
            coaSubheadOptions: [],
            errors: [],
            isSaving: false,
            acc_error: ""
        }
    },
    methods: {
        coa_dropdown() {
            this.isSaving = true;
            this.$Progress.start();
            ApiService.post("/finance/chart-of-accounts/subhead/dropdown")
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.coaSubheadOptions = response.data.coa_subheads
                })

        },
        addAccount() {
            if (this.entities.length < 1) {
                this.acc_error = "account can not be lesser then one"
                // this.isSaving = true
            } else {
                this.acc_error = ""
                // this.isSaving = false
            }
            if (this.entities.length > 0) {
                this.entities.push({ amount: "", coa_subhead: { id: "", name: "", code: "" } });

            }
        },
        removeField(index) {
            if (this.entities.length == 1) {
                this.acc_error = "account can not be lesser then one"
                // this.isSaving = true

            } else {
                this.acc_error = ""
                // this.isSaving = false
            }
            if (this.entities.length > 1) {
                this.entities.splice(index, 1);
            }
        },
        storeData() {
            this.isSaving = true;
            this.$Progress.start();

            this.form.coasubheads = this.entities;
            ApiService.post("/finance/chart-of-accounts/multiple-update-balance", this.form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();

                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });

                    this.resetForm();
                })
                .catch((error) => {
                    console.log(error);
                    this.isSaving = false;
                    this.$Progress.fail();
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors;
                    }
                });
        },
        resetForm() {
            this.form = this.initialState().form;
            this.entities = [{ amount: "", coa_subhead: { id: "", name: "", code: "" } }];
            // this.selectedCoaSubhead = this.initialState().selectedCoaSubhead;
            this.errors = [];
        },
        initialState() {
            return {
                form: {
                    coasubheads: [],
                    errors: [],
                    trans_date: "",
                },
                entities: [{ amount: "", coa_subhead: { id: "", name: "", code: "" } }],
            }
        },
        customLabel({ code, name, coabranch }) {
            return `${code} - ${name} - ${coabranch?.name ?? ""}`
        }
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>